export type UnitOfTime =
  | 'day'
  | 'hour'
  | 'minute'
  | 'month'
  | 'second'
  | 'year'
  | 's'
  | 'm'
  | 'h'
  | 'd'
  | 'M'
  | 'y'
  | 'years'
  | 'months'
  | 'week'
  | 'weeks'
  | 'w'
  | 'days'
  | 'hours'
  | 'minutes'
  | 'seconds'
  | 'millisecond'
  | 'milliseconds'
  | 'ms';
